export default "__VITE_ASSET__C8el0U5A__"